/**
 * Breadcrumb - Navegación de breadcrumb para recepción de devoluciones
 *
 * Componente de navegación que muestra la ruta actual en el proceso
 * de recepción de devoluciones. Incluye:
 * - Navegación entre diferentes vistas de recepción
 * - Información del estado y código de entrada
 * - Estilos consistentes con el diseño del sistema
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useIsMobile } from '@shared/hooks/useMobile';
import { useLocationOrderStatusName, getLocationOrderStatusColor } from '../../config';

interface BreadcrumbProps {
  returnedId: number;
  code: string;
  status: string;
}

export const Breadcrumb = ({ returnedId, code, status }: BreadcrumbProps) => {
  const { t } = useTranslation(['locationordersDetailModule', 'locationordersModule']);
  const isMobile = useIsMobile();
  const statusName = useLocationOrderStatusName(status);

  const breadcrumbs = useMemo(
    () => [
      // Solo mostrar "Órdenes de ubicación" en desktop
      ...(isMobile ? [] : [{ label: t('locationordersModule:breadcrumb.location_orders'), path: '/location-orders' }]),
      {
        label: (
          <div className="flex items-center gap-2">
            <span className="text-text">{code}</span>
            <span
              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getLocationOrderStatusColor(status)}`}
            >
              {statusName}
            </span>
          </div>
        ),
      },
    ],
    [returnedId, code, status, statusName, t, isMobile],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
